"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _exportNames = {
  TEXT_FONTS: true
};
exports.TEXT_FONTS = void 0;

var _tokens = require("./tokens.shared");

Object.keys(_tokens).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _tokens[key];
    }
  });
});

/**
 * font-families
 */
var TEXT_FONTS = {
  sans: '"ll-unica77", "Helvetica Neue", Helvetica, Arial, sans-serif',
  serif: '"adobe-garamond-pro", "Times New Roman", Times, serif'
};
exports.TEXT_FONTS = TEXT_FONTS;
//# sourceMappingURL=tokens.js.map